module.exports = __webpack_public_path__ + "static/media/tarja-linhas-profissional.8d3553f2.jpg";